import { Col, Row, Spinner } from 'reactstrap';
import SearchInput from 'components/SearchInput';
import PaginationNav from 'components/Pagination';
import useControllerExternalNewsListDragPage from './_presenters/useControllerExternalNewsListDragPage/';
import ExternalNewsItem from 'components/News/ExternalNewsItem';

const InternalsNewsListDragPage = () => {
  const {
    externalNews,
    isLoading,
    handleSearch,
    handlePageChange
  } = useControllerExternalNewsListDragPage();

  return (
    <div>
      <Row className="d-flex flex-column flex-md-row">
        <Col className="col-12 col-md mb-3 mt-3">
          <SearchInput
            onSearchTextChange={handleSearch}
            placeholder="Pesquisar notícias"
            optionalsButtons
          />
        </Col>
      </Row>
      <div className="table-campaign-drag">
        {isLoading && (
          <tr>
            <td colSpan={2} className="text-center p-5">
              <Spinner />
            </td>
          </tr>
        )}
        {externalNews?.items?.map((news) => (
          <ExternalNewsItem key={news.id} externalNews={news} />
        ))}
      </div>
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row mt-3">
        {externalNews && (
          <PaginationNav
            onChange={handlePageChange}
            totalPages={externalNews.totalPages}
            currentPage={externalNews.page}
          />
        )}
      </div>
    </div>
  );
};

export default InternalsNewsListDragPage;
